import type { Components, Theme } from '@mui/material';

export const dataGridThemeConfig: Components<Theme>['MuiDataGrid'] = {
  styleOverrides: {
    root: {
      boxShadow: '2px 4px 4px 2px rgba(0, 0, 0, 0.08)',
      border: 1,
      borderColor: '#d3d4d7',
      borderRadius: '8px',
    },
    row: {
      height: 'auto !important',
      minHeight: '48px !important',
      maxHeight: '100px !important',
      '&:hover': {
        backgroundColor: 'rgba(204, 240, 249, 0.608)',
      },
      backgroundColor: 'rgba(0, 0, 0, 0.02)',
      '&:nth-of-type(odd)': {
        backgroundColor: '#fff',

        '&:hover': {
          backgroundColor: 'rgba(204, 240, 249, 0.608)',
        },
      },
    },
    withBorderColor: {
      borderColor: 'transparent', // border between rows
    },
    columnHeaderTitle: {
      padding: '16px 24px',
      fontSize: 14,
      fontWeight: 500,
      color: '#252A36',
    },
    columnHeader: {
      backgroundColor: '#fff',
      borderBottom: '1px solid #d3d4d7 !important',
      padding: '0px',
      '&.menuIcon': {
        marginRight: '0px',
      },
      '&:focus': {
        outline: 'none',
      },
      '&:focus-within': {
        outline: 'none',
      },
    },
    menuIcon: {
      marginRight: '0px',
      zIndex: '110',
    },
    cell: {
      padding: '16px 24px',
      color: '#51555e',
      // hide the border between cells when clicking on a cell
      '&:focus': {
        outline: 'none',
        border: 'none',
      },
      '&.MuiDataGrid-cell--editing': {
        outline: 'none',
        border: 'none',
      },
      '&:focus-within': {
        outline: 'none',
        border: 'none',
      },
    },
  },
};

export const tableRowThemeConfig: Components<Theme>['MuiTableRow'] = {
  styleOverrides: {
    root: {
      '&:hover': { backgroundColor: 'yellow' },
    },
  },
};
